/** URL hash and element id that land the unit detail page on its Invoices section. */
export const INVOICES_SECTION_ID = "invoices";
